export const BATTLES_TAB_CURRENT_INFO_ID = 'BATTLES_TAB_CURRENT_INFO';
